import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'asm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem('customers', {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      search: filter.search,
      cluster: filter.cluster
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem('customers')
}

export {
  setTableOptions,
  getTableOptions
}
